<ds-alert [type]="AlertTypeEnum.Error" [dismissible]="false">
  <!-- Using [innerHTML] instead of {{message}} allows to render HTML code -->
  <span [innerHTML]="message"></span>
</ds-alert>
